import { render, staticRenderFns } from "./PartnerAdminDashboard.vue?vue&type=template&id=7053329a&scoped=true&"
import script from "./PartnerAdminDashboard.vue?vue&type=script&lang=ts&"
export * from "./PartnerAdminDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7053329a",
  null
  
)

export default component.exports